import { useState } from "react";
import { TrafficSource } from "../../../services/TrafficSource";

export const useSubmitTrafficSourceLogic = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const saveTrafficSource = async (data) => {
    try {
      setIsSubmitting(true);
      const trafficSource = await TrafficSource.addTrafficSource(data);
      setIsSubmitting(false);
      if (trafficSource.success) {
        return {
          success: true,
          data: trafficSource.data.trafficSource,
          msg: trafficSource.msg
        };
      } else {
        throw new Error(
          trafficSource?.error?.message || "Unable to save link type"
        );
      }
    } catch (error) {
      setIsSubmitting(false);
      return {
        success: false,
        msg: error.message || "Unable to save link type",
        data: null
      };
    }
  };

  const updateTrafficSource = async (id, data) => {
    try {
      setIsSubmitting(true);
      const trafficSource = await TrafficSource.updateTrafficSource(id, data);
      setIsSubmitting(false);
      if (trafficSource.success) {
        return {
          success: true,
          data: trafficSource.data.trafficSource,
          msg: trafficSource.msg
        };
      } else {
        throw new Error(
          trafficSource?.error?.message || "Unable to update Traffic Type"
        );
      }
    } catch (error) {
      setIsSubmitting(false);
      return {
        success: false,
        msg: error.message || "Unable to update Traffic Type",
        data: null
      };
    }
  };

  return {
    saveTrafficSource,
    isSubmitting,
    updateTrafficSource
  };
};
